import React from 'react';
import demoImg from '../../assets/demo/3-ways-to-use-xpaths-with-large-site-audits-760x400.png';
function DemoScreen() {
    return (
        <div style={styles.main}>
            <img src={demoImg} alt='' />
        </div>
    );
}

const styles = {
    main: {
        backgroundImage: { demoImg },
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
    },
};

export default DemoScreen;
